module.exports = __webpack_public_path__ + "img/blank_slate.57db379.svg";